import { render, staticRenderFns } from "./McInlineForm.vue?vue&type=template&id=a740172a&scoped=true&"
import script from "./McInlineForm.vue?vue&type=script&lang=js&"
export * from "./McInlineForm.vue?vue&type=script&lang=js&"
import style0 from "./McInlineForm.vue?vue&type=style&index=0&id=a740172a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a740172a",
  null
  
)

export default component.exports